import React from 'react';
import './SocialLinks.css';

const SocialLinks = ({ links = [] }) => {
  if (links.length === 0) return null;

  return (
    <section className="social-section" aria-labelledby="social-links-title">
      <h2 id="social-links-title" className="visually-hidden">
        Social Media Links
      </h2>
      <ul className="social-links">
        {links.map((link, index) => (
          <li key={index} className={`social-link social-link--${link.type}`}>
            <a
              href={link.url}
              target="_blank"
              rel="noopener"
              accessKey={link.accessKey}
              title={link.title}
              aria-label={link.ariaLabel}
            >
              <span>{link.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SocialLinks;

